import { render, staticRenderFns } from "./LocalVideo.vue?vue&type=template&id=0c11fe6c&scoped=true"
import script from "./LocalVideo.vue?vue&type=script&lang=js"
export * from "./LocalVideo.vue?vue&type=script&lang=js"
import style0 from "./LocalVideo.vue?vue&type=style&index=0&id=0c11fe6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c11fe6c",
  null
  
)

export default component.exports